/*export const bucketUrl = 'https://iqvnzdxbkjfxtndgvmqh.supabase.co/storage/v1/object/public/main/'*/
export const bucketUrl = import.meta.env.VITE_BUCKET_URL
export const apiUrl = import.meta.env.VITE_API_URL
